module.exports = __webpack_public_path__ + "img/12.822fc6d6.jpg";